<template>
  <v-container style="max-width: 1000px;">
    <v-card v-if="!!items" class="my-4 pa-4">
      <p class="text-h6">Rate Sheet</p>
      <v-divider></v-divider>
      <v-simple-table class="table--striped" dense>
        <template v-slot:default>
          <tbody>
            <tr v-for="(item, index) in items" :key="'rate-' + index">
              <td width="90%">{{ item.name }}</td>
              <td width="10%">
                <v-btn
                  type="button"
                  color="primary"
                  text
                  link
                  small
                  @click="downloadFileWithUrl(item.src, item.name, 'pdf')"
                >
                  Download <v-icon small>mdi-download</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
import { common } from "@/mixins";

export default {
  name: "RateSheets",
  async mounted() {
    const response = await this.$store
      .dispatch("inforesource/getRateSheetAll")
      .then((resp) => resp)
      .catch((err) => err);

    this.items = response.data;
  },
  data() {
    return {
      items: null,
    };
  },
  methods: {},
  mixins: [common],
};
</script>
